import script from "./End.vue?vue&type=script&setup=true&lang=ts"
export * from "./End.vue?vue&type=script&setup=true&lang=ts"

import "./End.vue?vue&type=style&index=0&id=13c53c61&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13c53c61"]])

export default __exports__